import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentacionCorreoService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description Documentacion correo
   * @params data
   */
  postDocumentationEmail(data: any): Observable<ArrayBuffer> {
    const headerConfig: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };

    return this.http.post(
      environment.endpoints.urlBase +
      environment.endpoints.documentacionCorreo.name,
      data,
      headerConfig
    );
  }
}
